import { render } from "./TheKnNav.vue?vue&type=template&id=a6171a6c&scoped=true&ts=true"
import script from "./TheKnNav.vue?vue&type=script&lang=ts"
export * from "./TheKnNav.vue?vue&type=script&lang=ts"

import "./TheKnNav.vue?vue&type=style&index=0&id=a6171a6c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6171a6c"]])

export default __exports__